import { render } from "./myInvestments.vue?vue&type=template&id=514e043b&scoped=true"
import script from "./myInvestments.vue?vue&type=script&lang=js"
export * from "./myInvestments.vue?vue&type=script&lang=js"

import "./myInvestments.vue?vue&type=style&index=0&id=514e043b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514e043b"]])

export default __exports__